/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDisclosure } from "@jumbo/components/JumboDialog/hooks/useDisclosure";
import DialogDefault from "@jumbo/components/JumboDialog/components/DialogDefault";

import Stack from "@mui/material/Stack";
import {
  Badge,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Card, CardContent } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

import { usePagination } from "app/hooks/usePagination";
import { Table } from "app/components";
import Div from "@jumbo/shared/Div";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import Loader from "@jumbo/components/Loader";
import { userType } from "app/helpers/userType";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import ChangeStatus from "../dialog/change-status";
import {
  downloadInvoice,
  getInvoiceList,
  updateInvoiceStatus,
} from "app/redux/slice/invoiceSlice";
import moment from "moment";
import { getSupplierList } from "app/redux/slice/supplierSlice";
import Span from "@jumbo/shared/Span";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import FilePreview from "../dialog/file-preview";
import { useNavigate } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { officeOrderDispatchedView } from "app/routes/constant";
import JumboAutoComplete from "@jumbo/components/JumboAutoComplete";
import { FileDownload } from "@mui/icons-material";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

const DispatchedList = () => {
  const { stageAction } = useDisclosure();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { isMA } = userType();
  const navigate = useNavigate();

  const supplierData = useSelector((state) => state?.supplier);
  const invoiceData = useSelector((state) => state?.invoice);

  const [searchText, setSearchText] = useState("");
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("createdAt");
  const [supplierId, setSupplierId] = useState();
  const [dispatchStatus, setDispatchStatus] = useState("Pending");
  const [statusOf, setStatusOf] = useState();

  const {
    isOpen: isOpenPaymentStatus,
    onClose: closePaymentStatus,
    actionProps: paymentStatusActionProps,
    stageAction: changeStatusStageAction,
  } = useDisclosure();
  const {
    isOpen: isOpenFilePreview,
    onClose: closeFilePreview,
    actionProps: filePreviewActionProps,
    stageAction: filePreviewStageAction,
  } = useDisclosure();
  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    usePagination({ id: "dispatched" });
  const [permissionData] = useState(
    JSON.parse(localStorage.getItem("permission")),
  );

  const [permission, setPermission] = useState({
    changeStatusPermission: false,
    downloadPermission: false,
  });
  const getPermission = () => {
    if (isMA) {
      setPermission({
        changeStatusPermission: true,
        downloadPermission: true,
      });
    } else {
      let permissionValue = {
        changeStatusPermission: false,
        downloadPermission: false,
      };
      permissionData?.length &&
        permissionData.forEach(function (num) {
          if (num?.name === "manage-status-invoice") {
            permissionValue.changeStatusPermission = true;
          }
          if (num?.name === "download-invoice") {
            permissionValue.downloadPermission = true;
          }
        });
      setPermission(permissionValue);
    }
  };

  const handleDocumentDownload = async (row, type = "invoice") => {
    const response = await dispatch(
      downloadInvoice({ id: row?._id, type }),
    ).unwrap();
    if (response?.status === 200) {
      const byteCharacters = atob(response?.data?.data?.base64);
      const byteNumbers = Array.from(byteCharacters)?.map((char) =>
        char.charCodeAt(0),
      );
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {
        type: "application/pdf",
      });

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      const documentType = type === "challan" ? "challan" : "invoice";
      const referenceNumber =
        type === "challan"
          ? row?.challanNumber || row?.invoiceNumber
          : row?.invoiceNumber || row?.challanNumber;

      link.href = url;
      link.download = `${documentType}-${referenceNumber || "download"}.pdf`;
      link.click();
      URL.revokeObjectURL(url);
    } else {
      enqueueSnackbar(response.data?.responseMessage, {
        variant: "error",
      });
    }
  };

  const columns = [
    {
      id: "invoiceDate",
      minWidth: 100,
      label: "Date",
      sort: true,
      render: (row) => moment(row?.invoiceDate).format("DD-MM-YYYY"),
    },
    { id: "invoiceNumber", label: "Inv No.", sort: true, minWidth: 90 },
    {
      id: "supplier",
      label: "Belongs To",
      sort: false,
      render: (row) => row?.supplier?.user?.name,
    },
    {
      id: "vendor",
      label: "Vendor",
      minWidth: 90,
      render: (row) => row?.supplier?.name,
    },
    {
      id: "PO",
      label: "Del.Status",
      render: (row) => row?.PO?.deliveryType,
    },
    {
      id: "dispatchStatus",
      label: "Status",
      sort: true,
      render: (row) =>
        row?.dispatchStatus === "pending" ? (
          <Span style={{ color: "red" }}>Pending</Span>
        ) : (
          <Span style={{ color: "green" }}>Dispatched</Span>
        ),
    },
    { id: "challanNumber", label: "Challan No.", sort: true, minWidth: 120 },
    { id: "markaNumber", label: "Marka No", sort: true, minWidth: 110 },
    {
      id: "actions",
      label: "Actions",
      minWidth: 250,
      align: "center",
      render: (row) => (
        <>
          <IconButton
            onClick={() => {
              navigate(officeOrderDispatchedView(row?._id));
            }}
          >
            <VisibilityIcon />
          </IconButton>
          <IconButton
            disabled={!permission.changeStatusPermission}
            onClick={() => {
              setStatusOf("dispatch");
              changeStatusStageAction(row);
            }}
          >
            <LocalShippingIcon />
          </IconButton>
          <Tooltip title="Download Invoice">
            <span>
              <IconButton
                disabled={!permission.downloadPermission}
                onClick={() => handleDocumentDownload(row, "invoice")}
              >
                <FileDownload />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title="Download Challan">
            <span>
              <IconButton
                disabled={!permission.downloadPermission}
                onClick={() => handleDocumentDownload(row, "challan")}
              >
                <DescriptionOutlinedIcon />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip
            title={
              row?.paymentProofCount
                ? `Files - ${row.paymentProofCount} payment proof(s) from App`
                : "Files"
            }
          >
            <IconButton
              onClick={() => {
                filePreviewStageAction(row);
              }}
            >
              {/* Count of payment proofs the vendor uploaded from the App. */}
              <Badge
                badgeContent={row?.paymentProofCount || 0}
                color="error"
                max={99}
              >
                <FolderOpenIcon />
              </Badge>
            </IconButton>
          </Tooltip>
        </>
      ),
    },
  ];

  const handleSubmit = async (data) => {
    if (statusOf !== "payment") {
      const formData = new FormData();
      if (data?.markaNumber) formData.append("markaNumber", data?.markaNumber);
      formData.append(
        "paymentStatus",
        `${data?.paymentStatus ? "paid" : "unpaid"}`,
      );
      formData.append(
        "dispatchStatus",
        `${data?.dispatchStatus === true ? "dispatched" : "pending"}`,
      );
      data?.files?.forEach((file) => {
        formData.append("dispatchStatusImage", file);
      });
      // Only sent when Admin picked one - leaving it out keeps whatever LR
      // copy the dispatch already has.
      if (data?.lrCopy) formData.append("lrCopy", data.lrCopy);
      const response = await dispatch(
        updateInvoiceStatus({ id: data?.invoiceId, data: formData }),
      ).unwrap();
      if (response.status === 200) {
        enqueueSnackbar(response.data?.responseMessage, {
          variant: "success",
        });
        getData();
        closePaymentStatus();
      } else {
        enqueueSnackbar(response.data?.responseMessage, {
          variant: "error",
        });
        closePaymentStatus();
      }
    }
  };

  const getData = () => {
    localStorage.setItem("dispatched-search", searchText.trim());
    const value = {
      page: page,
      perPage: rowsPerPage,
      search: searchText.trim(),
      paymentStatus: "paid",
      ...(supplierId && { supplierId: supplierId._id }),
      ...(dispatchStatus !== "All" && {
        dispatchStatus: dispatchStatus === "Pending" ? "pending" : "dispatched",
      }),
    };
    if (orderBy !== "") {
      value.sort = order === "asc" ? 1 : -1;
      value.field = orderBy;
    }
    dispatch(getInvoiceList(value));
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleChangePage(0, 0);
      getData();
    }
  };

  const sortData = (Order, OrderBy) => {
    setOrder(Order);
    setOrderBy(OrderBy);
  };

  useEffect(() => {
    getPermission();
    dispatch(getSupplierList({ sort: 1, field: "name", type: "Office" }));
  }, []);

  useEffect(() => {
    getData();
  }, [page, rowsPerPage, dispatch, order, orderBy]);

  return (
    <>
      {invoiceData?.loading ? (
        <Loader />
      ) : (
        <>
          <Card sx={{ display: "flex", mb: 3 }}>
            <Div sx={{ display: "flex", flexDirection: "column", flex: "1" }}>
              <CardContent>
                <Grid container spacing={{ xs: 2, md: 3 }}>
                  <Grid item xs={12} sm={5}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Search"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      onKeyPress={handleKeyPress}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            style={{
                              display: searchText === "" ? "none" : "flex",
                            }}
                            onClick={() => setSearchText("")}
                          >
                            <ClearIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <JumboAutoComplete
                      options={supplierData?.list || []}
                      label="Vendor"
                      size="small"
                      getOptionLabel={(option) => option?.name}
                      name={`supplierId`}
                      value={supplierId}
                      onChange={(evt, value) => setSupplierId(value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <FormControl fullWidth>
                      <InputLabel>Status</InputLabel>
                      <Select
                        name="dispatchStatus"
                        id="dispatchStatus"
                        value={dispatchStatus}
                        label="Status"
                        size="small"
                        onChange={(e) => setDispatchStatus(e.target.value)}
                      >
                        <MenuItem></MenuItem>
                        {["All", "Pending", "Dispatched"].map((val) => {
                          return <MenuItem value={val}>{val}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <Button
                      fullWidth
                      type="submit"
                      variant="contained"
                      onClick={() => {
                        handleChangePage(0, 0);
                        getData();
                      }}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Div>
          </Card>
          <Card>
            <CardContent>
              <Stack
                justifyContent="space-between"
                direction={{ xs: "column", sm: "row" }}
                sx={{ mb: 3 }}
              >
                <Typography variant={"h2"} mb={0}>
                  Invoice List
                </Typography>
              </Stack>
              <Table
                columns={columns}
                rows={invoiceData?.list}
                page={page}
                rowsPerPage={rowsPerPage}
                Order={order}
                count={invoiceData?.total}
                OrderBy={orderBy}
                sortData={sortData}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                editAction={stageAction}
              />
            </CardContent>
          </Card>
          {permission.changeStatusPermission && (
            <DialogDefault
              open={isOpenPaymentStatus}
              onClose={closePaymentStatus}
              content={
                <ChangeStatus
                  value={paymentStatusActionProps}
                  onClose={closePaymentStatus}
                  handleSubmit={handleSubmit}
                  statusOf={statusOf}
                />
              }
              title={
                statusOf === "payment"
                  ? "Change Payment Status"
                  : "Change Dispatch Status"
              }
              fullWidth={false}
              maxWidth={"xs"}
              actions={<></>}
            />
          )}

          <DialogDefault
            open={isOpenFilePreview}
            onClose={closeFilePreview}
            content={
              <FilePreview
                value={filePreviewActionProps}
                onClose={closeFilePreview}
                handleSubmit={handleSubmit}
                type={"view"}
              />
            }
            title={"Files"}
            fullWidth={false}
            maxWidth={"lg"}
            actions={<></>}
          />
        </>
      )}
    </>
  );
};

export default DispatchedList;
